var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import styled from "styled-components";
const isWindowsPlatform = () => {
    if (typeof navigator === "undefined") {
        return false;
    }
    // Prefer userAgentData if available
    // @ts-expect-error userAgentData does not exist on Navigator
    const { userAgentData } = navigator;
    if (userAgentData === null || userAgentData === void 0 ? void 0 : userAgentData.platform) {
        return userAgentData.platform.toLowerCase().includes("win");
    }
    // Fallback to userAgent string
    return navigator.userAgent.toLowerCase().includes("win");
};
isWindowsPlatform();
/**
 * When the platform is Windows, wraps the frontend in a container which renders
 * more elegant scrollbars than Windows does by default.
 */
const BaseWrapper = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement("div", Object.assign({}, props, { style: Object.assign({ height: "100%" }, props.style) }), children));
};
const WindowsScrollbarWrapper = isWindowsPlatform()
    ? styled(BaseWrapper) `
        height: 100%;

        & ::-webkit-scrollbar {
          display: none;
          width: 8px;
          height: 8px;
        }

        & ::-webkit-scrollbar-track {
          visibility: hidden;
        }

        & *:hover::-webkit-scrollbar {
          display: unset;
        }

        & *:hover::-webkit-scrollbar-thumb {
          background: #bbb;
          border-radius: 4px;
        }
      `
    : BaseWrapper;
export default WindowsScrollbarWrapper;
